// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChipsItem__container-c82dde {
  max-width: 160px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--base-20);
  border-radius: 20px;
  padding: 4px;
  box-sizing: border-box;
  overflow: hidden;
}

.ChipsItem__container-c82dde + .ChipsItem__container-c82dde {
  margin-inline-start: var(--indent-8px);
}

.ChipsItem__title-f9e316 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  margin-inline-start: var(--indent-8px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ChipsItem__remove-container-ea8fcd {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-inline-start: 4px;
  cursor: pointer;
}

.ChipsItem__remove-container-ea8fcd:hover {
  background-color: var(--base-30);
}

@supports (display: block) {
  .ChipsItem__remove-container-ea8fcd:focus-visible {
    background-color: var(--base-30);
  }
}
.ChipsItem__remove-container-ea8fcd:active {
  background-color: var(--base-40);
}

.ChipsItem__remove-icon-f739b4 {
  width: 24px;
  height: 24px;
  fill: var(--base-110);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Chips/ChipsItem/ChipsItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AACA;EACE,sCAAA;AAEF;;AACA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,sCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;AAEF;;AACA;EACE,gCAAA;AAEF;;AACA;EACE;IACE,gCAAA;EAEF;AACF;AACA;EACE,gCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  max-width: 160px;\n  height: 40px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: var(--base-20);\n  border-radius: 20px;\n  padding: 4px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n.container + .container {\n  margin-inline-start: var(--indent-8px);\n}\n\n.title {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  margin-inline-start: var(--indent-8px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.remove-container {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  margin-inline-start: 4px;\n  cursor: pointer;\n}\n\n.remove-container:hover {\n  background-color: var(--base-30);\n}\n\n@supports (display: block) {\n  .remove-container:focus-visible {\n    background-color: var(--base-30);\n  }\n}\n\n.remove-container:active {\n  background-color: var(--base-40);\n}\n\n.remove-icon {\n  width: 24px;\n  height: 24px;\n  fill: var(--base-110);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChipsItem__container-c82dde`,
	"title": `ChipsItem__title-f9e316`,
	"remove-container": `ChipsItem__remove-container-ea8fcd`,
	"removeContainer": `ChipsItem__remove-container-ea8fcd`,
	"remove-icon": `ChipsItem__remove-icon-f739b4`,
	"removeIcon": `ChipsItem__remove-icon-f739b4`
};
module.exports = ___CSS_LOADER_EXPORT___;
